import API from "serviceshift-ui/api-client";

// Admin pay-by-link actions (TB-1884). The URLs come from the invoice payload
// (`invoice.links.payby` / `revoke_pay_link`) so the front end never hardcodes
// paths; send is POST, revoke is DELETE on the same endpoint.

interface SendPayLinkParams {
  url: string;
  phoneNumber?: string;
}

interface RevokePayLinkParams {
  url: string;
}

interface SendResult {
  sent: boolean;
  invoice_id: number;
}

interface RevokeResult {
  revoked: boolean;
  invoice_id: number;
}

export default {
  async sendPayLink(
    _: unknown,
    { url, phoneNumber }: SendPayLinkParams
  ): Promise<SendResult> {
    const response = await API.makeRequest<SendResult>(url, {
      method: "POST",
      data: phoneNumber ? { phone_number: phoneNumber } : {}
    });
    return response.data;
  },

  async revokePayLink(
    _: unknown,
    { url }: RevokePayLinkParams
  ): Promise<RevokeResult> {
    const response = await API.makeRequest<RevokeResult>(url, {
      method: "DELETE"
    });
    return response.data;
  }
};
